@charset "UTF-8";

/* src/app/system-view/system-view-new/system-view-new-item/system-view-new-item.component.scss */
:host ::ng-deep .ant-menu {
  background: var(--tem-chrome, var(--tem-surface)) !important;
  color: var(--tem-ink);
  font-family: var(--tem-font-family);
}
:host ::ng-deep .ant-menu .ant-menu-item,
:host ::ng-deep .ant-menu .ant-menu-submenu-title {
  color: var(--tem-ink);
}
:host ::ng-deep .ant-menu .ant-menu-item .anticon,
:host ::ng-deep .ant-menu .ant-menu-submenu-title .anticon {
  color: var(--tem-deep);
}
:host ::ng-deep .ant-menu .ant-menu-item:hover,
:host ::ng-deep .ant-menu .ant-menu-submenu-title:hover {
  color: var(--tem-deep);
  background: var(--tem-accent-soft);
}
:host ::ng-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
  background: var(--tem-accent-soft);
  color: var(--tem-deep);
}
:host ::ng-deep .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected::after {
  border-inline-end-color: var(--tem-accent);
}
/*# sourceMappingURL=system-view-new-item.component.css.map */
